function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.55295 17.1059C10.4506 17.1055 12.2936 16.4702 13.7884 15.3012L18.4883 20.0011L20 18.4893L15.3002 13.7895C16.4698 12.2945 17.1054 10.4511 17.1059 8.55295C17.1059 3.83707 13.2688 0 8.55295 0C3.83707 0 0 3.83707 0 8.55295C0 13.2688 3.83707 17.1059 8.55295 17.1059ZM8.55295 2.13824C12.0907 2.13824 14.9677 5.01523 14.9677 8.55295C14.9677 12.0907 12.0907 14.9677 8.55295 14.9677C5.01523 14.9677 2.13824 12.0907 2.13824 8.55295C2.13824 5.01523 5.01523 2.13824 8.55295 2.13824Z",
  fill: "#20205D"
});

var SvgSearchBarIcon = function SvgSearchBarIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearchBarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search-bar-icon.259e0191.svg";
export { ForwardRef as ReactComponent };